(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-aluminium"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kc-aluminium-studio')) {
  customElements.define('kc-aluminium-studio', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const root = this.closest('.kca');
      this.addEventListener('click', (event) => {
        const layout = event.target.closest('[data-layout-option]');
        const tone = event.target.closest('[data-tone-option]');
        if (!layout && !tone) return;
        if (layout) {
          this.dataset.layout = layout.dataset.layoutOption;
          this.querySelectorAll('[data-layout-option]').forEach(button => button.setAttribute('aria-pressed', String(button === layout)));
          this.querySelector('[data-selected-layout]').textContent = layout.querySelector('[data-option-title]').textContent;
          this.querySelectorAll('[data-advice]').forEach(p => p.hidden = p.dataset.advice !== this.dataset.layout);
        }
        if (tone) {
          this.dataset.tone = tone.dataset.toneOption;
          this.querySelectorAll('[data-tone-option]').forEach(button => button.setAttribute('aria-pressed', String(button === tone)));
          this.querySelector('[data-selected-color]').textContent = tone.querySelector('[data-color-title]').textContent;
        }
        this.querySelector('[data-announcement]').textContent = this.querySelector('[data-selected-layout]').textContent + ' · ' + this.querySelector('[data-selected-color]').textContent;
      }, options);
      const rail = root.querySelector('.photo-rail');
      const prev = root.querySelector('[data-gallery-prev]');
      const next = root.querySelector('[data-gallery-next]');
      const updateArrows = () => {
        prev.disabled = rail.scrollLeft < 3;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
      };
      const move = direction => rail.scrollBy({ left: direction * (rail.querySelector('figure').getBoundingClientRect().width + 24), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      rail.addEventListener('scroll', updateArrows, { ...options, passive: true });
      rail.addEventListener('keydown', event => {
        if (event.target !== rail) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.resize?.disconnect();
      this.resize = new ResizeObserver(updateArrows);
      this.resize.observe(rail);
      updateArrows();
      const dialog = root.querySelector('.photo-dialog');
      let trigger;
      root.querySelectorAll('.photo-open').forEach(button => button.addEventListener('click', () => {
        trigger = button;
        const image = button.querySelector('img').cloneNode();
        image.loading = 'eager';
        image.sizes = '(min-width: 1000px) 960px, 94vw';
        dialog.querySelector('.dialog-image').replaceChildren(image);
        dialog.querySelector('.dialog-caption').textContent = button.closest('figure').querySelector('h3').textContent;
        dialog.showModal();
      }, options));
      dialog.querySelector('.dialog-close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } }, options);
      dialog.addEventListener('close', () => trigger?.focus({ preventScroll: true }), options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-deuren"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kc-deuren-studio')) {
 customElements.define('kc-deuren-studio',class extends HTMLElement {
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
   this.choices=this.choices||{outside:'AP60',inside:'AP44'};this.side=this.side||'outside';this.favorites=this.favorites||[];
   const cards=[...this.querySelectorAll('[data-panel]')],colors=[...this.querySelectorAll('[data-color]')];
   this.selected=this.selected||cards[0].dataset.panel;
   const text=key=>this.querySelector('[data-text-'+key+']').textContent;
   const colorName=c=>c.dataset.color+' · '+c.querySelector('[data-color-title]').textContent;
   const cardFor=code=>cards.find(c=>c.dataset.panel===code);
   const colorFor=code=>colors.find(c=>c.dataset.color===code);
   const motion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';
   const updateRails=()=>{this.querySelectorAll('[data-rail]').forEach(rail=>{const name=rail.dataset.rail;this.querySelector('[data-rail-prev="'+name+'"]').disabled=rail.scrollLeft<3;this.querySelector('[data-rail-next="'+name+'"]').disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-3;});};
   const updateSelection=()=>{
    const list=this.querySelector('[data-favorites]');list.replaceChildren();
    this.favorites.forEach(code=>{const chip=document.createElement('div');chip.className='favorite-chip';const choose=document.createElement('button');choose.type='button';choose.dataset.favoriteView=code;choose.textContent=cardFor(code).querySelector('[data-panel-title]').textContent;const remove=document.createElement('button');remove.type='button';remove.dataset.favoriteRemove=code;remove.setAttribute('aria-label',text('remove')+' '+code);remove.textContent='×';chip.append(choose,remove);list.append(chip);});
    this.querySelector('[data-empty-favorites]').hidden=this.favorites.length>0;
    this.querySelector('[data-favorite-add]').disabled=this.favorites.includes(this.selected);
    this.querySelector('[data-selection-text]').value=text('models')+': '+(this.favorites.length?this.favorites.join(', '):text('no-model'))+'\n'+text('outside')+': '+colorName(colorFor(this.choices.outside))+'\n'+text('inside')+': '+colorName(colorFor(this.choices.inside));
    this.querySelector('[data-copy-feedback]').textContent=this.copyDefault;
   };
   const renderPanel=()=>{
    const card=cardFor(this.selected),source=card.querySelector('img');cards.forEach(c=>c.setAttribute('aria-pressed',String(c===card)));
    const im=source.cloneNode();im.loading='eager';im.sizes='(min-width: 1240px) 530px, (min-width: 701px) 46vw, 90vw';this.querySelector('[data-selected-image]').replaceChildren(im);
    this.querySelector('[data-selected-title]').textContent=card.querySelector('[data-panel-title]').textContent;
    this.querySelector('[data-selected-description]').textContent=card.querySelector('[data-panel-description]').textContent;
    const visible=cards.filter(c=>!c.hidden),idx=visible.indexOf(card);this.querySelector('[data-stage-count]').textContent=String(idx+1).padStart(2,'0')+' / '+visible.length;
    this.querySelector('[data-panel-step="-1"]').disabled=idx<=0;this.querySelector('[data-panel-step="1"]').disabled=idx>=visible.length-1;
    this.querySelector('[data-favorite-feedback]').textContent=this.favorites.includes(this.selected)?text('saved'):this.favoriteDefault;
    this.querySelector('[data-announcement]').textContent=card.querySelector('[data-panel-title]').textContent+' · '+card.querySelector('[data-panel-description]').textContent;
    updateSelection();
   };
   const renderColors=()=>{
    const c=colorFor(this.choices[this.side]);colors.forEach(b=>b.setAttribute('aria-pressed',String(b===c)));const im=c.querySelector('img').cloneNode();im.loading='eager';im.sizes='220px';this.querySelector('[data-sample]').replaceChildren(im);
    this.querySelector('[data-sample-title]').textContent=colorName(c);this.querySelector('[data-family-title]').textContent=c.querySelector('[data-family-title]').textContent;
    this.querySelectorAll('[data-side-option]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.sideOption===this.side)));
    this.querySelector('[data-color-side]').textContent=this.querySelector('[data-side-option="'+this.side+'"]').textContent;
    ['outside','inside'].forEach(s=>this.querySelector('[data-'+s+'-summary]').textContent=colorName(colorFor(this.choices[s])));
    this.querySelector('[data-announcement]').textContent=this.querySelector('[data-color-side]').textContent+' · '+colorName(c);updateSelection();
   };
   this.kcQuoteDesign=()=>({kind:'doors',models:(this.favorites.length?this.favorites:[this.selected]).map(code=>cardFor(code).querySelector('[data-panel-title]').textContent.trim()),outside:colorName(colorFor(this.choices.outside)),inside:colorName(colorFor(this.choices.inside))});
   this.copyDefault=this.querySelector('[data-copy-feedback]').textContent;this.favoriteDefault=this.querySelector('[data-favorite-feedback]').textContent;
   const dialog=this.querySelector('dialog');const close=()=>dialog.close();
   this.addEventListener('click',async event=>{
    const panel=event.target.closest('[data-panel]'),step=event.target.closest('[data-panel-step]'),filter=event.target.closest('[data-panel-filter]'),color=event.target.closest('[data-color]'),side=event.target.closest('[data-side-option]'),colorFilter=event.target.closest('[data-color-filter]');
    if(panel){this.selected=panel.dataset.panel;renderPanel();}
    if(step){const visible=cards.filter(c=>!c.hidden),idx=visible.indexOf(cardFor(this.selected));this.selected=visible[Math.max(0,Math.min(visible.length-1,idx+Number(step.dataset.panelStep)))].dataset.panel;renderPanel();}
    if(filter){cards.forEach(c=>c.hidden=filter.dataset.panelFilter!=='all'&&c.dataset.kind!==filter.dataset.panelFilter);this.querySelectorAll('[data-panel-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filter)));if(cardFor(this.selected).hidden)this.selected=cards.find(c=>!c.hidden).dataset.panel;this.querySelector('[data-rail="panels"]').scrollLeft=0;renderPanel();updateRails();}
    if(side){this.side=side.dataset.sideOption;renderColors();}
    if(color){this.choices[this.side]=color.dataset.color;renderColors();}
    if(colorFilter){colors.forEach(c=>c.hidden=colorFilter.dataset.colorFilter!=='all'&&c.dataset.family!==colorFilter.dataset.colorFilter);this.querySelectorAll('[data-color-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===colorFilter)));this.querySelector('[data-rail="colors"]').scrollLeft=0;updateRails();}
    if(event.target.closest('[data-favorite-add]')){if(this.favorites.length>=3){this.querySelector('[data-favorite-feedback]').textContent=text('full');}else if(!this.favorites.includes(this.selected)){this.favorites.push(this.selected);updateSelection();this.querySelector('[data-favorite-feedback]').textContent=text('added');}}
    const remove=event.target.closest('[data-favorite-remove]');if(remove){this.favorites=this.favorites.filter(c=>c!==remove.dataset.favoriteRemove);updateSelection();}
    const view=event.target.closest('[data-favorite-view]');if(view){this.selected=view.dataset.favoriteView;this.querySelector('[data-panel-filter="all"]').click();renderPanel();this.querySelector('#kce-groot').scrollIntoView({behavior:motion(),block:'start'});}
    if(event.target.closest('[data-copy]')){const area=this.querySelector('[data-selection-text]');try{await navigator.clipboard.writeText(area.value);this.querySelector('[data-copy-feedback]').textContent=text('copied');}catch{area.focus();area.select();this.querySelector('[data-copy-feedback]').textContent=text('copy-fallback');}}
    const arrow=event.target.closest('[data-rail-prev],[data-rail-next]');if(arrow){const name=arrow.dataset.railPrev||arrow.dataset.railNext,rail=this.querySelector('[data-rail="'+name+'"]'),first=[...rail.children].find(c=>!c.hidden);rail.scrollBy({left:(arrow.dataset.railPrev?-1:1)*(first.getBoundingClientRect().width+16)*2,behavior:motion()});}
    if(event.target.closest('[data-enlarge]')){const im=this.querySelector('[data-selected-image] img').cloneNode();im.sizes='(min-width: 760px) 720px, 94vw';dialog.querySelector('.dialog-image').replaceChildren(im);dialog.querySelector('.dialog-caption').textContent=this.querySelector('[data-selected-title]').textContent;dialog.showModal();}
   },opts);
   dialog.querySelector('.dialog-close').addEventListener('click',close,opts);dialog.addEventListener('close',()=>this.querySelector('[data-enlarge]').focus({preventScroll:true}),opts);
   dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}},opts);
   this.resize?.disconnect();this.resize=new ResizeObserver(updateRails);
   this.querySelectorAll('[data-rail]').forEach(rail=>{rail.addEventListener('scroll',updateRails,{...opts,passive:true});this.resize.observe(rail);rail.addEventListener('keydown',e=>{if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;e.preventDefault();const visible=[...rail.children].filter(c=>!c.hidden),idx=visible.indexOf(e.target.closest('[data-panel],[data-color]')),dir=e.key==='ArrowRight'?1:-1;if(idx>=0)visible[Math.max(0,Math.min(visible.length-1,idx+dir))].focus();else rail.scrollBy({left:dir*300,behavior:motion()});},opts);});
   renderPanel();renderColors();updateRails();
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-keralit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kc-keralit-picker')) {
  customElements.define('kc-keralit-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.model = '143'; this.family = 'all'; this.color = 'c21';
      this.colors = Array.from(this.querySelectorAll('[data-color]'));
      this.models = Array.from(this.querySelectorAll('[data-model]'));
      this.querySelector('select[data-family]').addEventListener('change', e => { this.family = e.target.value; this.update(); }, { signal });
      this.addEventListener('click', e => {
        const model = e.target.closest('[data-model]');
        if (model) { this.model = model.dataset.model; this.update(); }
        const color = e.target.closest('[data-color]');
        if (color) { this.color = color.dataset.color; this.update(); }
        if (e.target.closest('[data-color-prev]')) this.step(-1);
        if (e.target.closest('[data-color-next]')) this.step(1);
        for (const [key, rail, direction] of [['model-prev','.model-rail',-1],['model-next','.model-rail',1],['rail-prev','.color-rail',-1],['rail-next','.color-rail',1]]) {
          if (e.target.closest('[data-'+key+']')) this.querySelector(rail).scrollBy({left:direction*this.querySelector(rail).clientWidth*.75,behavior:this.motion()});
        }
      }, { signal });
      const swipe=this.querySelector('[data-swipe]');
      swipe.addEventListener('pointerdown',e=>{this.start={x:e.clientX,y:e.clientY};}, { signal });
      swipe.addEventListener('pointerup',e=>{if(!this.start)return;const dx=e.clientX-this.start.x,dy=e.clientY-this.start.y;this.start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5)this.step(dx<0?1:-1);}, { signal });
      swipe.addEventListener('pointercancel',()=>{this.start=null;}, { signal });
      this.classList.add('is-ready'); this.update(false);
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
    motion(){return matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';}
    eligible(){return this.colors.filter(c=>c.dataset.models.split(' ').includes(this.model)&&(this.family==='all'||c.dataset.family===this.family));}
    step(n){const list=this.eligible();const i=list.findIndex(c=>c.dataset.color===this.color);this.color=list[(i+n+list.length)%list.length].dataset.color;this.update();const c=list.find(c=>c.dataset.color===this.color),rail=this.querySelector('.color-rail');rail.scrollTo({left:c.offsetLeft-rail.offsetLeft-rail.clientWidth/2+c.clientWidth/2,behavior:this.motion()});}
    update(announce=true){
      const list=this.eligible();if(!list.some(c=>c.dataset.color===this.color))this.color=list[0].dataset.color;
      this.colors.forEach(c=>{c.hidden=!list.includes(c);c.setAttribute('aria-pressed',String(c.dataset.color===this.color));});
      this.models.forEach(m=>m.setAttribute('aria-pressed',String(m.dataset.model===this.model)));
      const c=list.find(x=>x.dataset.color===this.color),m=this.models.find(x=>x.dataset.model===this.model),name=c.querySelector('.color-name').textContent,group=c.querySelector('.color-family').textContent,model=m.querySelector('.model-name').textContent;
      const sample=this.querySelector('[data-swipe] img'),source=c.querySelector('img');sample.srcset=source.srcset;sample.sizes='(min-width: 900px) 550px, 100vw';sample.src=source.src;sample.alt=source.alt;
      for(const [sel,value] of [['color-title',name],['color-group',group],['selected-model',model],['selected-color',name],['selected-width',m.querySelector('.model-width').textContent],['selected-direction',m.querySelector('.model-direction').textContent],['selected-family',group],['color-count',String(list.length)]]) this.querySelector('[data-'+sel+']').textContent=value;
      if(announce)this.querySelector('[data-announcement]').textContent=model+' · '+name+' · '+group;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-kunststof"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kc-kunststof-studio')) {
  customElements.define('kc-kunststof-studio', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.choices = this.choices || { outside: 'AP60', inside: 'AP44' };
      const rail = this.querySelector('.color-rail');
      const cards = [...this.querySelectorAll('[data-color]')];
      const prev = this.querySelector('[data-color-prev]');
      const next = this.querySelector('[data-color-next]');
      const title = card => card.dataset.color + ' · ' + card.querySelector('[data-color-title]').textContent;
      const announce = () => { this.querySelector('[data-announcement]').textContent = this.querySelector('[data-selected-layout]').textContent + ' · ' + this.querySelector('[data-view-title]').textContent + ' · ' + this.querySelector('[data-selected-color]').textContent; };
      const render = () => {
        const side = this.dataset.side;
        const chosen = cards.find(card => card.dataset.color === this.choices[side]);
        this.style.setProperty('--frame', chosen.dataset.tone);
        cards.forEach(card => card.setAttribute('aria-pressed', String(card === chosen)));
        this.querySelector('[data-selected-color]').textContent = title(chosen);
        this.querySelector('[data-sample-title]').textContent = title(chosen);
        this.querySelector('[data-family-title]').textContent = chosen.querySelector('[data-family-title]').textContent;
        const source = chosen.querySelector('img');
        if (source) {
          const sample = source.cloneNode(); sample.loading = 'eager'; sample.sizes = '176px';
          this.querySelector('[data-sample]').replaceChildren(sample);
        }
        this.querySelectorAll('[data-side-option]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sideOption === side)));
        this.querySelector('[data-view-title]').textContent = this.querySelector('[data-side-option="' + side + '"]').textContent;
        this.querySelector('[data-color-side]').textContent = this.querySelector('[data-side-label-' + side + ']').textContent;
        for (const s of ['outside', 'inside']) this.querySelector('[data-' + s + '-summary]').textContent = title(cards.find(card => card.dataset.color === this.choices[s]));
      };
      this.kcQuoteDesign=()=>({kind:'windows',layout:this.querySelector('[data-selected-layout]').textContent.trim(),outside:title(cards.find(c=>c.dataset.color===this.choices.outside)),inside:title(cards.find(c=>c.dataset.color===this.choices.inside))});
      const arrows = () => { prev.disabled = rail.scrollLeft < 3; next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3; };
      const move = dir => {
        const card = cards.find(card => !card.hidden);
        rail.scrollBy({ left: dir * (card.getBoundingClientRect().width + 14) * 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.addEventListener('click', event => {
        const layout = event.target.closest('[data-layout-option]');
        const side = event.target.closest('[data-side-option]');
        const color = event.target.closest('[data-color]');
        const filter = event.target.closest('[data-filter]');
        if (layout) {
          this.dataset.layout = layout.dataset.layoutOption;
          this.querySelectorAll('[data-layout-option]').forEach(button => button.setAttribute('aria-pressed', String(button === layout)));
          this.querySelector('[data-selected-layout]').textContent = layout.querySelector('[data-option-title]').textContent;
          this.querySelectorAll('[data-advice]').forEach(p => p.hidden = p.dataset.advice !== this.dataset.layout);
          announce();
        }
        if (side) { this.dataset.side = side.dataset.sideOption; render(); announce(); }
        if (color) { this.choices[this.dataset.side] = color.dataset.color; render(); announce(); }
        if (filter) {
          cards.forEach(card => card.hidden = filter.dataset.filter !== 'all' && card.dataset.family !== filter.dataset.filter);
          this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
          rail.scrollLeft = 0; arrows();
        }
      }, options);
      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      rail.addEventListener('scroll', arrows, { ...options, passive: true });
      rail.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const visible = cards.filter(card => !card.hidden);
        if (event.target === rail) { move(event.key === 'ArrowRight' ? 1 : -1); return; }
        const current = visible.indexOf(event.target.closest('[data-color]'));
        if (current >= 0) visible[Math.max(0, Math.min(visible.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1)))].focus();
      }, options);
      this.resize?.disconnect(); this.resize = new ResizeObserver(arrows); this.resize.observe(rail);
      render(); arrows();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-schuifpui"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kc-schuifpui-studio')) {
  customElements.define('kc-schuifpui-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.state = {model:'slide2',material:'pvc',direction:'right',opening:0,filter:'all',colors:{pvc:'AP60',alu:'RAL7016'}};
      this.q = s => this.querySelector(s);
      this.qa = s => Array.from(this.querySelectorAll(s));
      this.text = key => this.q('[data-text="'+key+'"]').textContent.trim();
      this.on = (node,type,fn) => node.addEventListener(type,fn,{signal:this.abort.signal});
      this.qa('[data-model]').forEach(button => this.on(button,'click',()=>{
        this.state.model=button.dataset.model;
        if (['slide3','fold5'].includes(this.state.model)) this.state.material='alu';
        this.update(true);
      }));
      this.qa('[data-material]').forEach(button=>this.on(button,'click',()=>{
        this.state.material=button.dataset.material;
        this.state.filter='all';
        this.update(true);
        this.q('[data-rail="colors"]').scrollLeft=0;
      }));
      this.qa('[data-direction]').forEach(button=>this.on(button,'click',()=>{this.state.direction=button.dataset.direction;this.update(true);}));
      this.on(this.q('[data-opening]'),'input',event=>{this.state.opening=Number(event.target.value);this.draw();this.openingLabel();});
      this.qa('[data-open]').forEach(button=>this.on(button,'click',()=>{this.state.opening=Number(button.dataset.open);this.q('[data-opening]').value=this.state.opening;this.draw();this.openingLabel();}));
      this.qa('[data-color]').forEach(button=>this.on(button,'click',()=>{this.state.colors[this.state.material]=button.dataset.color;this.update(true);}));
      this.qa('[data-filter]').forEach(button=>this.on(button,'click',()=>{this.state.filter=button.dataset.filter;this.colorVisibility();this.q('[data-rail="colors"]').scrollLeft=0;}));
      this.qa('[data-rail-next],[data-rail-prev]').forEach(button=>this.on(button,'click',()=>{
        const name=button.dataset.railNext||button.dataset.railPrev,rail=this.q('[data-rail="'+name+'"]');
        rail.scrollBy({left:(button.dataset.railNext?1:-1)*rail.clientWidth*.75,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }));
      this.qa('[data-rail]').forEach(rail=>{
        this.on(rail,'scroll',()=>this.railButtons(rail));
        this.on(rail,'keydown',event=>{
          if(!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)||event.target===rail)return;
          const buttons=Array.from(rail.querySelectorAll('button')).filter(b=>!b.hidden),index=buttons.indexOf(event.target);
          if(index<0)return;
          event.preventDefault();
          const next=event.key==='Home'?0:event.key==='End'?buttons.length-1:Math.max(0,Math.min(buttons.length-1,index+(event.key==='ArrowRight'?1:-1)));
          buttons[next].focus();
        });
      });
      ['[data-width]','[data-height]'].forEach(selector=>this.on(this.q(selector),'input',()=>this.summary(true)));
      ['[data-project-type]','[data-glass]'].forEach(selector=>this.on(this.q(selector),'change',()=>this.summary(true)));
      this.on(this.q('[data-copy]'),'click',async()=>{
        const value=this.q('[data-summary]').value;
        try {await navigator.clipboard.writeText(value);this.q('[data-copy-feedback]').textContent=this.text('copied');}
        catch {this.q('[data-summary]').focus();this.q('[data-summary]').select();this.q('[data-copy-feedback]').textContent=this.text('fallback');}
      });
      this.observer=new ResizeObserver(()=>this.qa('[data-rail]').forEach(rail=>this.railButtons(rail)));
      this.qa('[data-rail]').forEach(rail=>this.observer.observe(rail));
      this.update(false);
    }
    disconnectedCallback() {this.abort?.abort();this.abort=null;this.observer?.disconnect();}
    selectedColor() {return this.q('[data-color="'+this.state.colors[this.state.material]+'"]');}
    selectedModel() {return this.q('[data-model="'+this.state.model+'"]');}
    update(announce) {
      const s=this.state,model=this.selectedModel(),color=this.selectedColor(),isAlu=s.material==='alu',onlyAlu=['slide3','fold5'].includes(s.model);
      this.qa('[data-model]').forEach(b=>b.setAttribute('aria-pressed',b===model));
      this.qa('[data-material]').forEach(b=>{b.setAttribute('aria-pressed',b.dataset.material===s.material);b.disabled=onlyAlu&&b.dataset.material==='pvc';});
      this.qa('[data-direction]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.direction===s.direction));
      this.q('[data-material-note]').textContent=this.text(onlyAlu?'aluminium-only':'mixed');
      this.q('[data-direction-group]').hidden=s.model==='slide4';
      this.q('[data-center-note]').hidden=s.model!=='slide4';
      this.q('[data-selected-model]').textContent=model.querySelector('[data-model-name]').textContent;
      this.q('[data-selected-description]').textContent=model.querySelector('[data-model-description]').textContent;
      this.q('[data-pvc-color-note]').hidden=isAlu;
      this.q('[data-pvc-extra]').hidden=isAlu;
      this.q('[data-alu-color-note]').hidden=!isAlu;
      this.q('[data-color-filters]').hidden=isAlu;
      this.q('[data-current-color]').textContent=color.dataset.color.replace('RAL','RAL ')+' · '+color.querySelector('[data-color-title]').textContent;
      const sample=color.querySelector('img,.ral-swatch').cloneNode(true);
      if(sample.tagName==='IMG')sample.loading='eager';
      this.q('[data-current-sample]').replaceChildren(sample);
      this.q('[data-scene]').style.setProperty('--frame',color.dataset.tone);
      this.colorVisibility();
      this.draw();
      this.openingLabel();
      this.summary(announce);
      if(announce)this.q('[data-announcement]').textContent=this.q('[data-selected-model]').textContent+' · '+this.q('[data-material="'+s.material+'"]').textContent+' · '+this.q('[data-current-color]').textContent;
    }
    colorVisibility() {
      this.qa('[data-color]').forEach(b=>{
        b.hidden=b.dataset.materialColor!==this.state.material||(this.state.material==='pvc'&&this.state.filter!=='all'&&b.dataset.family!==this.state.filter);
        b.setAttribute('aria-pressed',b.dataset.color===this.state.colors[b.dataset.materialColor]);
      });
      this.qa('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.filter===this.state.filter));
      this.qa('[data-rail]').forEach(rail=>this.railButtons(rail));
    }
    railButtons(rail) {
      const name=rail.dataset.rail,prev=this.q('[data-rail-prev="'+name+'"]'),next=this.q('[data-rail-next="'+name+'"]');
      prev.disabled=rail.scrollLeft<2;
      next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-3;
    }
    openingLabel() {
      const value=this.state.opening,label=value===0?this.text('closed'):value===100?this.text('open'):this.text('demo')+' · '+value+'%';
      this.q('[data-opening-state]').textContent=label;
      this.q('[data-opening]').setAttribute('aria-valuetext',label);
      this.qa('[data-open]').forEach(b=>b.setAttribute('aria-pressed',Number(b.dataset.open)===value));
    }
    svg(name,attributes) {
      const el=document.createElementNS('http://www.w3.org/2000/svg',name);
      Object.entries(attributes).forEach(([k,v])=>el.setAttribute(k,String(v)));
      return el;
    }
    draw() {
      const target=this.q('[data-panes]'),s=this.state,t=s.opening/100,total=640,height=304,frame=s.material==='alu'?9:13;
      target.replaceChildren();
      const pane=(x,width,handleAt,shade=0)=>{
        const g=this.svg('g',{'data-leaf':'',transform:'translate('+x+' 0)'});
        g.append(this.svg('rect',{x:0,y:0,width,height,fill:'#d7e9e8','fill-opacity':.16+shade,stroke:'#25232a','stroke-opacity':.2,'stroke-width':1}));
        g.append(this.svg('path',{d:'M '+frame+' '+frame+' L '+(width*.55)+' '+frame+' L '+frame+' '+height*.65+' Z',fill:'#fff','fill-opacity':.09}));
        for(const [a,b,c,d] of [[0,0,width,frame],[0,height-frame,width,frame],[0,0,frame,height],[width-frame,0,frame,height]])g.append(this.svg('rect',{x:a,y:b,width:c,height:d,'data-frame':''}));
        g.append(this.svg('path',{d:'M 2 '+(height-2)+' L 2 2 L '+(width-2)+' 2',fill:'none',stroke:'#fff','stroke-opacity':.24,'stroke-width':1}));
        if(handleAt){const hx=handleAt==='left'?frame+2:width-frame-7;g.append(this.svg('rect',{x:hx,y:height*.46,width:5,height:33,rx:2,fill:'#bbc0c0',stroke:'#555a5a','stroke-width':.6}));}
        target.append(g);
      };
      target.setAttribute('transform','translate(100 94)');
      if(s.model==='slide2') {
        const w=total/2;
        if(s.direction==='right'){pane(w,w,null);pane(w*t,w,'left',.04);}
        else {pane(0,w,null);pane(w*(1-t),w,'right',.04);}
      } else if(s.model==='slide3') {
        const w=total/3;
        if(s.direction==='right'){pane(w*2,w,null);pane(w+w*t,w,'left',.025);pane(w*2*t,w,'left',.06);}
        else {pane(0,w,null);pane(w*(1-t),w,'right',.025);pane(w*2*(1-t),w,'right',.06);}
      } else if(s.model==='slide4') {
        const w=total/4;
        pane(0,w,null);pane(w*3,w,null);pane(w*(1-t),w,'right',.04);pane(w*(2+t),w,'left',.04);
      } else {
        const w=total/5,projected=w*(1-.88*t),depth=24*t,start=s.direction==='left'?0:total-projected*5;
        for(let i=0;i<5;i++){
          const x=start+i*projected,y1=i%2?depth:0,y2=i%2?0:depth;
          const outer=`M ${x} ${y1} L ${x+projected} ${y2} L ${x+projected} ${height+y2} L ${x} ${height+y1} Z`;
          const g=this.svg('g',{'data-leaf':'','data-fold-width':projected});
          g.append(this.svg('path',{d:outer,fill:i%2?'#b5ccc8':'#e2eeed','fill-opacity':.2+t*.25,stroke:'var(--frame)','stroke-width':Math.max(5,frame*(1-.4*t)),'stroke-linejoin':'round'}));
          g.append(this.svg('path',{d:`M ${x+2} ${y1+2} L ${x+projected-2} ${y2+2}`,stroke:'#fff','stroke-opacity':.35,fill:'none'}));
          if((s.direction==='left'&&i===4)||(s.direction==='right'&&i===0))g.append(this.svg('rect',{x:x+projected/2-2,y:height*.46+depth/2,width:4,height:30,rx:2,fill:'#bbc0c0'}));
          target.append(g);
        }
      }
      this.q('[data-rail-third]').hidden=s.model!=='slide3';
    }
    summary(changed) {
      const s=this.state,readMeasure=selector=>{
        const field=this.q(selector),number=field.valueAsNumber,valid=field.value===''&&!field.validity.badInput||Number.isInteger(number)&&number>0&&number<=9999;
        field.setAttribute('aria-invalid',!valid);
        return valid&&field.value!==''?number+' cm':this.text('unknown');
      };
      const width=readMeasure('[data-width]'),height=readMeasure('[data-height]');
      this.q('[data-measure-note]').textContent=this.text(this.q('input[aria-invalid="true"]')?'measure-invalid':'measure-note');
      const direction=s.model==='slide4'?this.text('center'):this.q('[data-direction="'+s.direction+'"]').textContent+' ('+this.text('garden')+')';
      const selectedText=selector=>this.q(selector).selectedOptions[0].textContent;
      this.q('[data-summary]').value=[this.text('summary-title'),'',this.text('model')+': '+this.q('[data-selected-model]').textContent,this.text('material')+': '+this.q('[data-material="'+s.material+'"]').textContent,this.text('color')+': '+this.q('[data-current-color]').textContent,this.text('direction')+': '+direction,this.text('width')+': '+width,this.text('height')+': '+height,this.text('project')+': '+selectedText('[data-project-type]'),this.text('glass')+': '+selectedText('[data-glass]'),'',this.text('confirm')].join('\n');
      if(changed)this.q('[data-copy-feedback]').textContent=this.text('changed');
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offerte-formulier"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initQuoteForm() {
    const form = document.querySelector('.kc-quote #offerteForm');
    if (!form || form.dataset.kcqReady) return;
    form.dataset.kcqReady = 'true';
    form.addEventListener('submit', function () {
      const data = new FormData(form);
      const get = key => String(data.get('contact[' + key + ']') || '').trim();
      const productKeys = ['kozijn_vast_raam', 'kozijn_draai_kiep', 'kozijn_deur', 'kozijn_schuifpui', 'dakkapel', 'gevelbekleding', 'kozijn_anders'];
      const materialKeys = ['materiaal_kunststof', 'materiaal_aluminium', 'materiaal_hout'];
      const name = get('name');
      form.querySelector('[data-kcq-name]').value = name || 'Offerteaanvraag';
      form.querySelector('#contactBody').value = [
        'Offerteaanvraag Kozijnen Compleet',
        '',
        'Naam: ' + name,
        'E-mailadres: ' + get('email'),
        'Telefoonnummer: ' + get('telefoonnummer'),
        '',
        'PROJECTADRES',
        'Straat en huisnummer: ' + get('Straat en huisnummer'),
        'Postcode: ' + get('Postcode'),
        'Woonplaats: ' + get('woonplaats'),
        '',
        'Producten: ' + (productKeys.map(get).filter(Boolean).join(', ') || 'Nog te bespreken'),
        'Materiaal: ' + (materialKeys.map(get).filter(Boolean).join(', ') || 'Nog te bespreken'),
        'Montage: ' + (get('montage') || 'Nog te bespreken'),
        'Advies: ' + get('advies'),
        'Belmoment: ' + get('belmoment'),
        'Zakelijk: ' + get('zakelijk'),
        'Bedrijfsnaam: ' + get('Bedrijfsnaam'),
        '',
        'Gekozen ontwerp: ' + get('Ontwerp'),
        '',
        'Toelichting:',
        get('opmerkingen')
      ].join('\n');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initQuoteForm);
  else initQuoteForm();
  document.addEventListener('shopify:section:load', initQuoteForm);
})();

  } catch(e) { console.error(e); }
})();
})();
